// The client-side path producer for the scenario screens.
//
// One function, because the failure this lane fixed was three hand-written
// copies of a path that pointed at a root nobody had mounted. The backend has
// its own single producer (`orgScenarioDeepLink` in services/platform-graph/
// src/services/org-scenario-apply.ts).
//
// WHAT PINS WHAT — the earlier version of this comment claimed deep-link.test.ts
// pins BOTH producers; it did not, and the backend one had zero tests in the
// repo. Three gates now cover the pair, each where its inputs actually live:
//   * deep-link.test.ts (this package) reads router.tsx and pins THIS producer
//     against the mounted routes — same package, so Turbo sees the router as an
//     input and cannot serve a stale green.
//   * org-scenario-deep-link.test.ts (platform-graph) pins the BACKEND producer's
//     shape and that it never regrows the `/org-chart` root.
//   * `pnpm run scenarios:check` is the only gate that can compare the two,
//     because it is the only one that reads both packages — and it runs from the
//     repo root outside Turbo, so it has no cache to go stale.

/**
 * The list surface is a TAB of /org, not a page of its own — a standalone
 * `/org/scenarios` page would be a second URL for one screen AND would drop the
 * org tab strip, stranding the reader with no way back to the chart. The route
 * still exists and redirects here, so a typed or bookmarked `/org/scenarios`
 * resolves instead of hitting the catch-all.
 */
export const ORG_SCENARIOS_PATH = "/org?tab=scenarios";

/** The routed base the DETAIL screen and the backend deep link share. */
export const ORG_SCENARIO_ROUTE_BASE = "/org/scenarios";

export function orgScenarioPath(scenarioId: string): string {
  return `${ORG_SCENARIO_ROUTE_BASE}/${scenarioId}`;
}
